if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

document.querySelectorAll('.product-card__swatches, .product-card__sizes').forEach(el => {
  let scrollInterval = null;

  const ZONE_WIDTH = 50;  // px from edge that triggers scroll
  const SCROLL_SPEED = 6; // px per frame

  el.addEventListener('mousemove', e => {
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left;

    clearInterval(scrollInterval);

    if (x < ZONE_WIDTH) {
      // Left zone
      scrollInterval = setInterval(() => {
        el.scrollLeft -= SCROLL_SPEED;
      }, 16);
    } else if (x > rect.width - ZONE_WIDTH) {
      // Right zone
      scrollInterval = setInterval(() => {
        el.scrollLeft += SCROLL_SPEED;
      }, 16);
    }
  });

  el.addEventListener('mouseleave', () => {
    clearInterval(scrollInterval);
  });
});